import { render, staticRenderFns } from "./filter-panel.vue?vue&type=template&id=48d60e8d&"
import script from "./filter-panel.vue?vue&type=script&lang=js&"
export * from "./filter-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports